/* eslint-disable @next/next/no-img-element */
import { isEmpty, has, isArray } from "lodash";
import { useState, useImperativeHandle, useEffect } from "react";
import http from "../../utilities/http";
import { numberWithCommas } from "utilities/helper";
export default function Index({ parentState, parentSetState, ref, paramType = '', paramValue = '', notGraphQl = false, id = '', type = '' }) {
    // paramType: category_id, vendor_id
    const [selected, setSelected] = useState(parentState.filters);
    const [filtersList, setFilterList] = useState([]);

    useEffect(() => {
        const fetchFilter = async (page = 1) => {
            let condition = (paramType && paramValue) ? `${paramType}: { eq: "${paramValue}" }` : '';
            const res = await http('/graphql', {}, {
                token: 'default',
                method: 'POST',
                body: {
                    query: `{
                    products(filter: { ${condition} }) {
                        aggregations {
                            label
                            count
                            attribute_code
                            options {
                                label
                                value
                            }
                        }
                        
                    }
                }`}
            });
            const filterOptions = res?.data?.products?.aggregations || [];
            filterOptions.forEach(x => {
                x.options.map(y => y.field = x.attribute_code);
            });
            setFilterList(filterOptions.filter(x => x.attribute_code != 'price' && x.label != 'color_bucket' && x.label != 'approval_bucket' && x.attribute_code != 'category_id'));
        };

        const fetchFilterNotGrapql = async () => {
            let urlFilter = '';
            if (type == 'flashsale') {
                urlFilter = '/rest/V1/vne/flashsales/attribute';
            } else {
                urlFilter = `/rest/V1/vendors/dealhot/attributes/${id}`;
            }
            const result = await http(urlFilter, {}, { token: 'default' });
            const filterOptions = !isArray(result.attributes)
                ? Object.keys(result.attributes).map(x => {
                    return {
                        "label": result.attributes[x].label,
                        "attribute_code": x,
                        "options": result.attributes[x].options,
                    };
                })
                : (result.attributes).map(x => {
                    return {
                        "label": x.label,
                        "attribute_code": x.attribute,
                        "options": x.options,
                    };
                });
            filterOptions.forEach(x => {
                x.options.map(y => y.field = x.attribute_code);
            });
            setFilterList(filterOptions.filter(x => x.label && x.attribute_code != 'price' && x.label != 'color_bucket' && x.label != 'approval_bucket' && x.attribute_code != 'category_id'));
        };

        if (notGraphQl) {
            fetchFilterNotGrapql();
        } else {
            fetchFilter();
        }
    }, []);
    useImperativeHandle(ref, () => ({
        cleanSelected() {
            setSelected(parentState.filters);
        }
    }));
    const currentState = (term) => {
        const findTerm = selected.find(
            (f) => f.value === term.value && f.field === term.field
        );
        if (!findTerm) {
            if (term.field == 'price') {
                setSelected(selected.filter((f) => f.field !== 'price').concat([term]));
                return;
            }

            setSelected(selected.concat([term]));
        } else {
            if (term.value == 'price0') {
                setSelected(selected.filter((f) => f.value !== term.value).concat([term]));
                return;
            }
            setSelected(selected.filter((f) => f.value !== term.value));
        }
    };
    const selectFilter = () => {
        parentSetState({
            filters: selected,
            showFilter: ''
        });
    };
    const sort = [
        {
            value: 'best_discount,desc', label: 'Mức giảm giá tốt nhất'
        }, {
            value: 'price,asc', label: 'Giá tăng dần'
        }, {
            value: 'price,desc', label: 'Giá giảm dần'
        }, {
            value: 'rating_summary,desc', label: 'Đánh giá tốt nhất'
        },
    ];

    const filterPrice = [
        {
            field: "price",
            value: 'price1',
            label: "Dưới 2.000.000đ",
            condition: [
                {
                    value: "2000000",
                    condition_type: "lteq",
                }
            ]
        },
        {
            field: "price",
            value: 'price2',
            label: "2.000.000đ - 10.000.000đ",
            condition: [
                {
                    value: "2000000",
                    condition_type: "from",
                },
                {
                    value: "10000000",
                    condition_type: "to",
                }
            ]
        },
        {
            field: "price",
            value: 'price3',
            label: "10.000.000đ - 50.000.000đ",
            condition: [
                {
                    value: "10000000",
                    condition_type: "from",
                },
                {
                    value: "50000000",
                    condition_type: "to",
                }
            ]
        },
        {
            field: "price",
            value: 'price4',
            label: "50.000.000đ - 100.000.000đ",
            condition: [
                {
                    value: "50000000",
                    condition_type: "from",
                },
                {
                    value: "100000000",
                    condition_type: "to",
                }
            ]
        },
        {
            field: "price",
            value: 'price5',
            label: "Trên 100.000.000đ",
            condition: [
                {
                    value: "100000000",
                    condition_type: "gteq",
                },
            ]
        },
    ];

    const [priceFrom, setPriceFrom] = useState(null);
    const [priceTo, setPriceTo] = useState(null);
    const customPrice = {
        field: "price",
        value: "price0",
        label: `${numberWithCommas(priceFrom)} - ${numberWithCommas(priceTo)}`,
        condition: [
            {
                value: priceFrom <= priceTo ? priceFrom : priceTo,
                condition_type: "from",
            },
            {
                value: priceFrom <= priceTo ? priceTo : priceFrom,
                condition_type: "to",
            },
        ],
    };

    const setCustomPrice = (isFrom, value) => {
        value = +value;

        if (isFrom) {
            if (value == 0) {
                setPriceFrom(null);
                return;
            }
            currentState({
                field: "price",
                value: "price0",
                label: `${numberWithCommas(value)} - ${numberWithCommas(priceTo)}`,
                condition: [
                    {
                        value: value <= priceTo ? value : priceTo,
                        condition_type: "from",
                    },
                    {
                        value: value <= priceTo ? priceTo : value,
                        condition_type: "to",
                    },
                ],
            });
            setPriceFrom(value);
        } else {
            if (value == 0) {
                setPriceTo(null);
                return;
            }
            currentState({
                field: "price",
                value: "price0",
                label: `${numberWithCommas(priceFrom)} - ${numberWithCommas(value)}`,
                condition: [
                    {
                        value: priceFrom <= value ? priceFrom : value,
                        condition_type: "from",
                    },
                    {
                        value: priceFrom <= value ? value : priceFrom,
                        condition_type: "to",
                    },
                ],
            });
            setPriceTo(value);
        }
    };

    return (
        <>
            <div className={`filter ${(parentState.showFilter || parentState.sortActive) ? "filter-m-p" : ''}`} style={{
                // 'zIndex': '2',
                whiteSpace: 'nowrap',
                overflowX: 'auto',
            }}>
                {parentState?.onSort &&
                    <div className="filterItem dropdown mr-2" style={{ display: 'inline-block' }}>
                        <button className="btn btn--dropdown" data-toggle="dropdown" style={{ zIndex: 3 }}
                            onClick={() => { parentSetState({ showFilter: '', sortActive: true }); }}
                        >Sắp xếp</button>
                        <div className={`pc-only dropdown-menu dropdown-menu--mw290 ${parentState.sortActive ? 'show' : ''} `} >
                            <div className="filterBox">
                                <div className="filterHeader">
                                    <span className="filter-tlt">Sắp xếp</span>
                                    <span className="filter-close" onClick={() => parentSetState({ sortActive: null })}><img src="/images/icon-close.png" alt="" /></span>
                                </div>
                                <ul className="filter-list">
                                    {sort?.map(x => {
                                        return <li key={x.value} className={x.value === parentState?.sort?.value ? 'active' : ''}
                                            onClick={() => parentSetState({
                                                sort: x,
                                                sortActive: false
                                            })}>{x?.label}</li>;
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                }

                <div className="filterItem dropdown mr-2" style={{ display: 'inline-block' }}>
                    <button className="btn btn--dropdown" data-toggle="dropdown" style={{ zIndex: 3 }}
                        onClick={() => {
                            parentSetState({ showFilter: 'Khoảng giá', sortActive: false });
                            setSelected(parentState.filters);
                        }}
                    >Khoảng giá
                    </button>
                    <div className={`pc-only dropdown-menu dropdown-menu--mw290 ${parentState.showFilter === 'Khoảng giá' ? 'show' : ''} `} >
                        <div className="filterBox">
                            <div className="filterHeader">
                                <span className="filter-tlt">Khoảng giá</span>
                                <span className="filter-close" onClick={() => parentSetState({ showFilter: null })}><img src="/images/icon-close.png" alt="" /></span>
                            </div>
                            <ul className="filter-list">
                                {filterPrice.map(x => {
                                    const findTerm = !isEmpty(selected) && selected.find(f => f.value === x.value);
                                    return <li key={x.label} className={findTerm ? 'active' : ''} onClick={() => currentState(x)}>{x?.label}</li>;
                                })}
                                <li key='priceCustom'
                                    className={!isEmpty(selected) && selected.find(f => f.value === 'price0') ? 'active' : ''}
                                    onClick={() => currentState(customPrice)}>
                                    <input
                                        name="from"
                                        autoComplete="off"
                                        placeholder="0"
                                        className="form-control mr-3"
                                        type="number"
                                        onChange={(e) => setCustomPrice(true, e.target.value)}
                                        value={priceFrom} /> -
                                    <input
                                        name="to"
                                        autoComplete="off"
                                        placeholder="100000000"
                                        className="form-control ml-3"
                                        type="number"
                                        onChange={(e) => setCustomPrice(false, e.target.value)}
                                        value={priceTo} />
                                </li>
                            </ul>
                            <div className="filter-btn">
                                <button className="btn btn--blue" onClick={() => { selectFilter(); }}
                                >Áp dụng</button>
                            </div>
                        </div>
                    </div>
                </div>

                {filtersList?.map((item, index) =>
                    <div key={index} className="filterItem dropdown mr-2" style={{ display: 'inline-block' }}>
                        <button className="btn btn--dropdown" data-toggle="dropdown" style={{ zIndex: 3 }}
                            onClick={() => {
                                parentSetState({ showFilter: item.label, sortActive: false });
                                setSelected(parentState.filters);
                            }}
                        >{item.label}
                        </button>
                        <div className={`pc-only dropdown-menu dropdown-menu--mw290 ${parentState.showFilter === item.label ? 'show' : ''} `} >
                            <div className="filterBox">
                                <div className="filterHeader">
                                    <span className="filter-tlt">{item.label}</span>
                                    <span className="filter-close" onClick={() => parentSetState({ showFilter: null })}><img src="/images/icon-close.png" alt="" /></span>
                                </div>
                                <ul className="filter-list">
                                    {item.options?.filter(x => x.label != 133).map(x => {
                                        if (!x.value) return;
                                        const findTerm = !isEmpty(selected) && selected.find(f => f?.value === x.value);
                                        return <li key={x.value} className={findTerm ? 'active' : ''} onClick={() => currentState(x)}>{x?.label}</li>;
                                    })}
                                </ul>
                                <div className="filter-btn">
                                    <button className="btn btn--blue" onClick={() => { selectFilter(); }}
                                    >Áp dụng</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="filterItem">
                {parentState?.onSort && parentState.sortActive &&
                    <div className={`sp-only dropdown-menu dropdown-menu--mw290 ${parentState.sortActive ? 'show' : ''} `} >
                        <div className="filterBox">
                            <div className="filterHeader">
                                <span className="filter-tlt">Sắp xếp</span>
                                <span className="filter-close" onClick={() => parentSetState({ sortActive: null })}><img src="/images/icon-close.png" alt="" /></span>
                            </div>
                            <ul className="filter-list">
                                {sort?.map(x => {
                                    return <li key={x.value} className={x.value === parentState?.sort?.value ? 'active' : ''}
                                        onClick={() => parentSetState({
                                            sort: x,
                                            sortActive: false
                                        })}>{x?.label}</li>;
                                })}
                            </ul>
                        </div>
                    </div>
                }

                {parentState.showFilter === 'Khoảng giá' &&
                    <div className={`sp-only dropdown-menu dropdown-menu--mw290 ${parentState.showFilter === 'Khoảng giá' ? 'show' : ''} `} >
                        <div className="filterBox">
                            <div className="filterHeader">
                                <span className="filter-tlt">Khoảng giá</span>
                                <span className="filter-close" onClick={() => parentSetState({ showFilter: null })}><img src="/images/icon-close.png" alt="" /></span>
                            </div>
                            <ul className="filter-list">
                                {filterPrice.map(x => {
                                    const findTerm = !isEmpty(selected) && selected.find(f => f.value === x.value);
                                    return <li key={x.label} className={findTerm ? 'active' : ''} onClick={() => currentState(x)}>{x?.label}</li>;
                                })}
                                <li key='priceCustom'
                                    className={!isEmpty(selected) && selected.find(f => f.value === 'price0') ? 'active' : ''}
                                    onClick={() => currentState(customPrice)}>
                                    <input className="form-control mr-3" type="number" onChange={(e) => setCustomPrice(true, e.target.value)} value={priceFrom} /> - <input className="form-control ml-3" type="number" onChange={(e) => setCustomPrice(false, e.target.value)} value={priceTo} />
                                </li>
                            </ul>
                            <div className="filter-btn">
                                <button className="btn btn--blue" onClick={() => { selectFilter(); }}
                                >Áp dụng</button>
                            </div>
                        </div>
                    </div>
                }

                {parentState.showFilter && parentState.showFilter !== 'Khoảng giá' &&
                    <div className={`sp-only dropdown-menu dropdown-menu--mw290 show`}>
                        <div className="filterBox">
                            <div className="filterHeader">
                                <span className="filter-tlt">{parentState.showFilter} </span>
                                <span className="filter-close" onClick={() => parentSetState({ showFilter: null })}><img src="/images/icon-close.png" alt="" /></span>
                            </div>
                            <ul className="filter-list">
                                {((filtersList || []).find(x => x.label === parentState.showFilter)).options?.filter(x => x.label != 133).map(x => {
                                    if (!x.value) return;
                                    const findTerm = !isEmpty(selected) && selected.find(f => f?.value === x.value);
                                    return <li key={x.value} className={findTerm ? 'active' : ''} onClick={() => currentState(x)}>{x?.label}</li>;
                                })}
                            </ul>
                            <div className="filter-btn">
                                <button className="btn btn--blue" onClick={() => { selectFilter(); }}
                                >Áp dụng</button>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {(!isEmpty(parentState.filters) || parentState?.sort?.value) && <div className="categoryTag">
                <ul style={{
                    whiteSpace: 'nowrap',
                    width: '100%',
                    display: 'block',
                    overflowX: 'scroll'
                }}>
                    {parentState.sort?.value &&
                        <li key={parentState.sort?.value} style={{ display: 'inline-block' }}>
                            <span className="tag">{parentState.sort?.label}
                                <span className="item-close" onClick={() => {
                                    parentSetState({
                                        sort: {}
                                    });
                                }}></span>
                            </span>
                        </li>
                    }
                    {parentState.filters && parentState.filters.map(item =>
                        (item.label && <li key={item.value} style={{ display: 'inline-block' }}>
                            <span className="tag">{item.label}
                                <span className="item-close" onClick={() => {
                                    parentSetState({
                                        filters: parentState.filters.filter(f => f.value !== item.value)
                                    });
                                }}></span>
                            </span>
                        </li>)
                    )}
                </ul>
            </div>}
            {(!isEmpty(parentState.showFilter) || parentState.sortActive) && <div style={{ height: document.documentElement.scrollHeight }} div className="backdrop backdrop-filter" onClick={() => {
                parentSetState({ showFilter: '', sortActive: false });
                has(ref, ['current', 'cleanSelected']) && ref.current.cleanSelected();
            }}></div>}
        </>

    );
}
